class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn');
    this._scrollRaf = null;
    this._onScroll = this._onScroll.bind(this);
    if (this.link) {
      this.link.addEventListener('click', this.handler.bind(this));
    }
    /* Raw scroll + layout reads every tick fights StickyHeader and makes the header feel laggy on collection pages. Coalesce to one rAF per frame. */
    if (this.classList.contains('autoscroll_yes')) {
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }
  }
  _onScroll() {
    if (this._scrollRaf != null) return;
    this._scrollRaf = requestAnimationFrame(() => {
      this._scrollRaf = null;
      this.autoscrollhandler();
    });
  }
  handler(event){
    event.preventDefault();
    if(this.destroyed) return false;
    placeCollectionLoader();
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    var url = event.currentTarget.href;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        var container = false,
            _html = false;
        
        container = document.querySelector('.collection__container').lastElementChild;
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection__container').innerHTML;
        container.insertAdjacentHTML("afterend", _html);

        container = document.querySelector('infinity-button');
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('infinity-button');
        container.replaceWith(_html);

        document.querySelector('.collection_facets_loader').classList.remove('loading_now');
        window.dispatchEvent(new Event('resize'));
        requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
    });
  }
  autoscrollhandler(){
    if(!this.link || this.destroyed) return false;
    if(!this.link.classList.contains('autoscroll')) return false;
    var loader = document.querySelector('.collection_facets_loader');
    if (loader && loader.classList.contains('loading_now')) return false;
    var contY = parseInt(this.link.parentNode.offsetTop);
    var wY = this.getWindowHeight()+this.getWindowTopY();
    if( contY <= wY ) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
    }
  }
  getWindowHeight(){
    return window.innerHeight;
  }
  getWindowTopY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  disconnectedCallback(){
    this.destroyed = true;
    if (this._scrollRaf != null) {
      cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = null;
    }
    window.removeEventListener('scroll', this._onScroll);
  }
}
customElements.define('infinity-button', infinityButton);